import { DISPATCH_METHODS } from '~constants/address';

export const DELIVERY_TYPES_MAPPER = {
  [DISPATCH_METHODS.DELIVERY]: 'storeDelivery',
  [DISPATCH_METHODS.PICKUP]: 'inStore',
  [DISPATCH_METHODS.PEYA_DELIVERY]: 'peyaDelivery',

  both: 'both'
};
